import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import { supabase } from '../../../lib/supabase';

const ReviewOversightTable = ({ reviews, onRefresh }) => {
  const [loading, setLoading] = useState(false);

  const handleDeleteReview = async (reviewId) => {
    if (!confirm('Are you sure you want to delete this review? This action cannot be undone.')) {
      return;
    }

    try {
      setLoading(true);
      const { error } = await supabase
        ?.from('ratings')
        ?.delete()
        ?.eq('id', reviewId);

      if (error) throw error;
      
      alert('Review deleted successfully');
      onRefresh?.();
    } catch (err) {
      console.error('Error deleting review:', err);
      alert('Failed to delete review');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-card rounded-lg shadow-md border border-border overflow-hidden">
      <div className="p-6 border-b border-border">
        <h2 className="text-xl font-semibold text-foreground flex items-center gap-2">
          <Icon name="Star" size={24} />
          Review Moderation
        </h2>
        <p className="text-sm text-muted-foreground mt-1">
          Monitor and moderate user reviews, manage flagged content
        </p>
      </div>

      <div className="divide-y divide-border">
        {reviews?.map((review) => (
          <div key={review?.id} className="p-6 hover:bg-muted/30 transition-smooth">
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center gap-3">
                <div>
                  <p className="font-medium text-foreground text-sm">
                    {review?.from_user?.full_name} → {review?.to_user?.full_name}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    {review?.from_user?.email}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="flex items-center gap-1">
                  {[...Array(5)]?.map((_, i) => (
                    <Icon
                      key={i}
                      name="Star"
                      size={16}
                      className={i < review?.rating ? 'text-warning fill-warning' : 'text-muted'}
                    />
                  ))}
                </div>
                <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                  review?.rating <= 2 ? 'bg-destructive/10 text-destructive' :
                  review?.rating === 3 ? 'bg-warning/10 text-warning': 'bg-success/10 text-success'
                }`}>
                  {review?.rating}/5
                </span>
              </div>
            </div>

            <p className="text-sm text-foreground mb-3">{review?.review || 'No review text provided'}</p>

            <div className="flex items-center justify-between">
              <p className="text-xs text-muted-foreground">
                Posted {new Date(review?.created_at)?.toLocaleDateString()}
              </p>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => handleDeleteReview(review?.id)}
                  disabled={loading}
                  className="px-3 py-1.5 bg-destructive/10 text-destructive hover:bg-destructive/20 rounded-lg transition-smooth text-xs font-medium disabled:opacity-50 flex items-center gap-1"
                >
                  <Icon name="Trash2" size={14} />
                  Delete Review
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {reviews?.length === 0 && (
        <div className="p-12 text-center">
          <Icon name="Star" size={48} className="mx-auto text-muted-foreground mb-4" />
          <p className="text-muted-foreground">No flagged reviews found</p>
        </div>
      )}
    </div>
  );
};

export default ReviewOversightTable;